import React, { useEffect, useState } from "react";
import { Route, Switch, Redirect, useHistory } from "react-router-dom";

import Base from "./components/Common/Base";
import UsersList from "./views/UsersList/UsersList";
import Install from "./views/Install/Install";
import Code from "./views/Code/Code";
import Services from "./views/Services/Services";
import User from "./views/User/User";
import Campaign from "./views/Campaign";
import MessageList from "./views/MessageList";
import Login from "./views/Login";
import Charts from "./views/Charts/Charts";
import AddQuestion from "./views/AddQuestion";
import ChargeWithCode from "./views/ChargeWithCode";
import TopUsers from "./views/TopUsers/TopUsers";
import Tiket from "./views/Tiket/Tiket";
import AddNewGift from "./views/userPrivileges/addGift";

// اگر فایل constants/urls دارید، از همان استفاده کنید.
// این fallback فقط برای اجراست:
export const URLs = {
  LOGIN: "/login",
  USERS: "/",
  INSTALL: "/install",
  CODE: "/code",
  SERVICES: "/services",
  USER_INFORMATION: "/user-information",
  CAMPAIGN: "/campaign",
  MESSAGE: "/messages",
  CHART: "/chart",
  ADD_QUESTION: "/add-question",
  ChargeWithCode: "/charge-with-code",
  AddGift: "/AddGift",
  TOPUSERS: "/top-users",
  TIKET: "/tiket",
};

const Routes = () => {
  const history = useHistory();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const hasToken =
      !!localStorage.getItem("ACCESSTOKEN") ||
      !!localStorage.getItem("tokenApiNew");
    setIsLoggedIn(hasToken);
    setChecked(true);
  }, []);

  useEffect(() => {
    if (checked && !isLoggedIn) {
      history.replace(URLs.LOGIN);
    }
  }, [checked, isLoggedIn, history]);

  const changeState = (value) => setIsLoggedIn(!!value);

  if (!checked) return null;

  return (
    <Switch>
      {/* مسیر لاگین: اگر لاگین بود به خانه ریدایرکت کن */}
      <Route
        path={URLs.LOGIN}
        exact
        render={(props) =>
          isLoggedIn ? (
            <Redirect to={URLs.USERS} />
          ) : (
            <Login {...props} changeState={changeState} />
          )
        }
      />

      {/* بقیه مسیرها فقط وقتی لاگین هست */}
      {isLoggedIn ? (
        <Base changeState={changeState}>
          <Switch>
            <Route path={URLs.INSTALL} component={Install} />
            <Route path={URLs.CODE} component={Code} />
            <Route path={URLs.SERVICES} component={Services} />
            <Route path={URLs.USERS} exact component={UsersList} />
            <Route path={URLs.USER_INFORMATION} exact component={User} />
            <Route path={URLs.CAMPAIGN} exact component={Campaign} />
            <Route path={URLs.MESSAGE} exact component={MessageList} />
            <Route path={URLs.CHART} exact component={Charts} />
            <Route path={URLs.ADD_QUESTION} exact component={AddQuestion} />
            <Route
              path={URLs.ChargeWithCode}
              exact
              component={ChargeWithCode}
            />
            <Route path={URLs.AddGift} exact component={AddNewGift} />
            <Route path={URLs.TOPUSERS} exact component={TopUsers} />
            <Route path={URLs.TIKET} exact component={Tiket} />
            <Redirect to={URLs.USERS} />
          </Switch>
        </Base>
      ) : (
        <Redirect to={URLs.LOGIN} />
      )}
    </Switch>
  );
};

export default Routes;
